import InputError from "./InputError";

const Select = ({ placeholder, options, name, value, onChange, error }) => {
  return (
    <label htmlFor={name} className="input__label">
      <div className="select">
        <select
          className="input input--select"
          name={name}
          id={name}
          value={value}
          onChange={onChange}
        >
          <option disabled value="">
            {placeholder}
          </option>
          {options.map((opt) => (
            /** Checking if the option is an object or not. If it is an object, 
             * it will use the key and value properties. If it is not an object, 
             * it will use the value of the option. */
            <option
              key={typeof opt === "object" ? opt.key : opt}
              value={typeof opt === "object" ? opt.value : opt}
            >
              {typeof opt === "object" ? opt.key : opt}
            </option>
          ))}
        </select>
      </div>
      <InputError error={error} />
    </label>
  );
};

export default Select;
